import { LABEL_VALUE, LOGIN_VALUE } from "./StoreValueType";

export const LoginValue = (value) => ({
  type: LOGIN_VALUE,
  payload: value,
});

export const LabelValue = (value) => ({
  type: LABEL_VALUE,
  payload: value,
});
